<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo"> 
      <i class="fas fa-warehouse icon"></i>
        Remitentes
      </div>
      
      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul> 
            <li>
              <router-link :to="{name:'administratorHome'}" >
                <span >
                  <i class="fas fa-home icon"></i>                  
                   inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{name: 'remitent'}">
                <span>
                 <i class="fas fa-warehouse icon"></i>
                    Remitentes
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div slot="contenido">
        <div class="box">
          
          <b-button type="is-primary is-small" @click="openBasic()">Crear Remitente</b-button>

          <b-table type="is-primary"
          :data.sync="listRemitents.data"
            :loading="loading"            
            :is-fullwidth="true"
            
        
            paginated
            backend-pagination
            :total="listRemitents.total"
            :per-page="listRemitents.per_page"
            @page-change="chargeListRemitent"
          >
            <template slot-scope="props">
              <b-table-column field="id" label="ID" width="40" numeric>{{ props.row.id }}</b-table-column>

              <b-table-column searchable field="name" label="Nombre">{{ props.row.name }}</b-table-column>

              <b-table-column label="Action">
                        <b-button type="is-primary is-small" @click="editBasic(props.row.id)">Editar</b-button>

              </b-table-column>
            </template>
          </b-table>
          
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from '../../../../template/PlantillaContenido'
import CreateRemitent from "../../../../components/manteiners/remitent/CreateRemitent"
import EditRemitentVue from '../../../../components/manteiners/remitent/EditRemitent.vue';
import { RemitentService } from '../../../../services/models/remitent';

export default {
  components: {
    PlantillaContenido,
  },
  data() {
    return {
      remitent_id: null,
      listRemitents: [],
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5
    };
  },
  mounted: function() {
    this.chargeListRemitent();
  },
  methods: {
    openBasic() {
      this.$buefy.modal.open({
        parent: this,
        component: CreateRemitent,
        props: {          
          chargeListRemitent: this.chargeListRemitent,
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },  
    editBasic(id) {
     this.$buefy.modal.open({
        parent: this,
        component: EditRemitentVue,
        props: {          
          chargeListRemitent: this.chargeListRemitent,
          id:id
        },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    async chargeListRemitent() {
      this.loading = true;
      this.listRemitents = [];
      const {data : remitents} = await RemitentService.getAll();
      this.listRemitents = remitents;
      this.loading = false;
    }
  },
  
};
</script>

